var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomRead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.512a.8.8 0 01.465-.726l5.7-2.631a.8.8 0 01.67 0l5.7 2.63a.8.8 0 01.465.727V13.2a.8.8 0 01-.8.8H2.3a.8.8 0 01-.8-.8V5.512z",
    stroke: "#7D8085",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5l5.642 2.821a.8.8 0 00.716 0L14 5",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })));
}
export default __webpack_public_path__ + "static/bottom-read.192b3e7a.svg";
export { SvgBottomRead as ReactComponent };